import { boolean, mixed, object, ObjectSchema, string } from 'yup';

import { ContactStatusDto, CustomerItemDto } from '@/api/generated';
import { selectSearchOptionRequiredValidation } from '@/utils/form/selectSearchOptionOptional.validation.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix';
import {
  CreateContactFormModel,
  CreateContactFormModelInner,
} from '@/views/contactsCreate/model/CreateContactForm.model.ts';

export const useCreateContactFormValidationInner =
  (): ObjectSchema<CreateContactFormModelInner> => {
    const { t } = useTranslationWithPrefix('validation');

    return object().shape({
      companyPosition: string()
        .min(3, t('minLength', { min: 3 }))
        .nullable(),
      contactOwnerId: selectSearchOptionRequiredValidation<string>(string(), t),
      customer: mixed<CustomerItemDto>().nullable(),
      customerChanged: boolean().required(t('general.required')),
      displayName: string()
        .min(3, t('minLength', { min: 3 }))
        .required(t('general.required')),
      email: string().email(t('email')),
      firstName: string()
        .min(3, t('minLength', { min: 3 }))
        .required(t('general.required')),
      lastName: string()
        .min(3, t('minLength', { min: 3 }))
        .required(t('general.required')),
      name: string(),
      note: string().nullable(),
      phone: string(),
      status: selectSearchOptionRequiredValidation<ContactStatusDto>(string(), t),
    });
  };

export const useCreateContactFormValidation = (): ObjectSchema<CreateContactFormModel> => {
  const contactValidation = useCreateContactFormValidationInner();

  return object().shape({
    contact: contactValidation,
  });
};
